import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';

export interface AddInvestigationWorkNoteCommand {
  readonly investigationId: string;
  readonly body: string;
}
export interface AddInvestigationWorkNoteResult { workNoteId: string; }

@Injectable({ providedIn: 'root' })
export class AddInvestigationWorkNoteUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: AddInvestigationWorkNoteCommand): Observable<AddInvestigationWorkNoteResult> {
    this._state.setAddingWorkNote(true);
    this._state.setErrorWorkNotes(null);
    return this._repository.addWorkNote(command.investigationId, command.body).pipe(
      tap(() => { this._state.setAddingWorkNote(false); }),
      map((response) => ({ workNoteId: response.id })),
      catchError((error) => {
        this._state.setErrorWorkNotes(error.message || 'Failed to add work note');
        this._state.setAddingWorkNote(false);
        return throwError(() => error);
      }),
    );
  }
}
